<template>
  <div class="panel-body" v-if="working">
    <div class="row panel-heading">
      <div class="col-sm-12 text-center">
        <i class="fa fa-spinner fa-pulse fa-3x fa-fw"></i>
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'loading',

    props: ['working'],

  }


</script>